<template>
  <div v-if="visible" class="panel-yellow">
    <i class="fas fa-bell-exclamation icon" />
    <p class="content" v-if="isHtml">
      <span v-html="message" />
    </p>
    <p class="content" v-else>
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: "InnerPageMessage",
  meta: {
    description: "Componente para mostrar mensajes de alertas.",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      meta: {
        description: "Estable si el InnerPageMessage estará visible o no",
        example: "true"
      }
    },
    message: {
      type: String,
      default: () => {},
      meta: {
        description: "Mensaje mostrado en el interior del componente",
        example: "Mensaje Documentación"
      }
    },
    isHtml: {
      type: Boolean,
      default: false,
      meta: {
        description: "Establece si el mensaje es HTML o no",
        example: "true"
      }
    }
  },

  mounted() {}
};
</script>
<style scope>
.panel-yellow {
  display: flex;
  flex-direction: row;
  padding: 16px 25px 5px 18px;
  background: #fff5e8;
  border: 1px solid #fdac41;
  border-radius: 4px;
  margin: 3px;
}

.panel-yellow .icon {
  font-size: 22px;
  color: #af6708;
  margin-top: 3px;
}
.panel-yellow .content {
  color: #af6708;
  margin-left: 12px;
  text-align: left;
}
</style>
